module.exports = __webpack_public_path__ + "static/media/window2x.6feb55ef.png";